import { withTag, type AdPlatform } from "./types";

// Installed by `loadLinkedInInsight()` in marketing.js, which defines lintrk as a
// queue (`lintrk.q`) before insight.min.js loads, so early calls are kept.
type Lintrk = (action: "track", payload: { conversion_id: number }) => void;

declare global {
  interface Window {
    lintrk?: Lintrk;
  }
}

/**
 * LinkedIn Insight Tag. Conversion tokens are numeric Campaign Manager
 * conversion ids. The partner id is not part of the call; the snippet sets it
 * at load time.
 */
export const linkedIn: AdPlatform = {
  name: "LinkedIn",
  key: "linkedIn",
  accountIdKey: "ID_LINKEDIN_INSIGHT",
  send: withTag(
    () => window.lintrk,
    (lintrk, conversionId) => {
      // Anything but a plain run of digits is a config error: `Number()` alone
      // would let " ", "0x1de" and "1e7" through as 0, 478 and 10000000. Throw
      // rather than send one; the dispatcher reports it, the others still fire.
      if (!/^\d+$/.test(conversionId)) {
        throw new Error(
          `LinkedIn conversion id must be numeric, got "${conversionId}"`
        );
      }

      lintrk("track", { conversion_id: Number(conversionId) });
    }
  )
};
